import nBossConnection from 'modules/base/service/nBossConnection';
import ReviewTableService from 'app/admin/review/service/ReviewTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'reviewTable',
	text: 'Kérdés vélemény',
	textKey: 'review',
	service: ReviewTableService,
	icon: 'person',
	editFormState: item => `/kerdes-velemeny/edit/${item ? item.id : 'new'}`,
	toolbarAction: [/*'filter',*/'export', 'refresh'/*, 'new'*/],
	rowAction: [/*'exportData',*/'modify', 'delete'],
	exportData: {
		tooltip: 'Export to XLSX',
		link: item => `${nBossConnection.basePath}reviewTableControl/exportToXlsx?id=${item.id}`
	},
	exportList: () => `${nBossConnection.basePath}reviewTableControl/exportToXlsx`,
	filterFields: [
		{
			propertyName: 'kerdes.csorszam',
			propertyType: 'String',
			type: 'LIKE'
		}
	],
	columns: [
		{
			key: 'kerdes.csorszam',
			text: 'Sorszám',
			textKey: 'kerdes.csorszam',
			type: 'text',
			sortable: false,
			disablePadding: false
		},
		{
			key: 'felhasznalo.name',
			text: 'Felhasználó',
			textKey: 'felhasznalo.name',
			type: 'text',
			sortable: false,
			disablePadding: false
		},
		{
			key: 'felhasznalo.email',
			text: 'Felhasználó email',
			textKey: 'felhasznalo.email',
			type: 'text',
			sortable: false,
			disablePadding: false
		},
		{
			key: 'kerdes.leirasPlaintext',
			text: 'Leírás',
			textKey: 'kerdes.leirasPlaintext',
			type: 'text',
			sortable: false,
			disablePadding: false
		},
	]
};

function ReviewTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('reviewTable', reducer('reviewTable'))(ReviewTable);
